var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}blank`,"viewBox":"0 0 16 16"}})
}
var staticRenderFns = []

export { render, staticRenderFns }